import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Media", -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Colors", -1)
const _hoisted_6 = { class: "d-flex flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_DigitalAssetUpload = _resolveComponent("DigitalAssetUpload")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.signageItemLayoutData
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "headline",
          label: "Headline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.headline,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signageItemLayoutData.headline) = $event)),
              placeholder: "Headline"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "subhead",
          label: "Subhead"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.subhead,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signageItemLayoutData.subhead) = $event)),
              placeholder: "Subhead"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" }),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_el_form_item, { label: "Use Media" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              class: "mt-1",
              modelValue: _ctx.signageItemLayoutData.useImage,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signageItemLayoutData.useImage) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.signageItemLayoutData.useImage)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Media"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DigitalAssetUpload, {
                  allowVideo: "false",
                  sizeLimitMB: "300",
                  layoutProperty: "asset1",
                  layoutType: _ctx.layoutType,
                  assetUrl: _ctx.assetUrl[0]
                }, null, 8, ["layoutType", "assetUrl"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" }),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "fontColor",
            label: "Font Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.fontColor,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.signageItemLayoutData.fontColor) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            placement: "top",
            content: "Using media background",
            "show-after": 0,
            "hide-after": 0,
            disabled: !_ctx.signageItemLayoutData.useBackgroundMedia
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                class: "signage__color-picker-wrapper",
                prop: "backgroundColor",
                label: "Background Color"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_color_picker, {
                    class: "mt-1",
                    modelValue: _ctx.signageItemLayoutData.backgroundColor,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.signageItemLayoutData.backgroundColor) = $event)),
                    disabled: _ctx.signageItemLayoutData.useBackgroundMedia
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createVNode(_component_el_form_item, { label: "Use Background Media" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              class: "mt-1",
              modelValue: _ctx.signageItemLayoutData.useBackgroundMedia,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.signageItemLayoutData.useBackgroundMedia) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.signageItemLayoutData.useBackgroundMedia)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Background Media"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DigitalAssetUpload, {
                  allowVideo: "true",
                  sizeLimitMB: "300",
                  layoutProperty: "asset2",
                  layoutType: _ctx.layoutType,
                  assetUrl: _ctx.assetUrl[1]
                }, null, 8, ["layoutType", "assetUrl"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}